import * as React from "react"
// @ts-ignore
import {PaintBrush, PaperPlaneTilt, ChartLineUp} from "@phosphor-icons/react"

const features = [
    {
        Icon: PaintBrush,
        title: "Designer templates",
        description:
            "Start with a polished template, then drag, drop, and refine. Brand-ready in minutes, not days.",
    },
    {
        Icon: PaperPlaneTilt,
        title: "Smart deliverability",
        description:
            "Authentication, warm-up, and send-time tuning are handled automatically so your campaigns reach the inbox.",
    },
    {
        Icon: ChartLineUp,
        title: "Built-in analytics",
        description:
            "Opens, clicks, conversions, and revenue attributed back to each send &mdash; the loop closes itself.",
    },
]

const Services = () => {
    return (
        <section className="w-full bg-white py-24">
            <div className="max-w-6xl mx-auto px-6">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 tracking-tight">
                        Everything you need. Nothing you don&rsquo;t.
                    </h2>
                    <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
                        A focused toolkit for marketers who&rsquo;d rather ship campaigns than wrestle with software.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {features.map(({Icon, title, description}, idx) => (
                        <div
                            key={idx}
                            className="rounded-2xl border border-slate-100 bg-white p-8 shadow-sm hover:shadow-lg transition-shadow duration-300">
                            <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center justify-center mb-5">
                                <Icon size={24} weight="duotone" color="#10B981"/>
                            </div>
                            <h3 className="text-xl font-semibold text-slate-900 mb-2">{title}</h3>
                            <p
                                className="text-base text-slate-600 leading-relaxed"
                                dangerouslySetInnerHTML={{__html: description}}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Services
